{
  "certificateAlerting": "hh:mm A",
  "filterValidityFormat": "YYYY-MM-DD",
  "date": "YYYY-MM-DD",
  "datetime": "YYYY-MM-DD hh:mm A",
  "time": "hh:mm A"
}
